import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "clinic-note-top" }
const _hoisted_4 = { class: "clinic-note-top-container" }
const _hoisted_5 = { class: "clinic-note-top-intro" }
const _hoisted_6 = { class: "clinic-note-top-title" }
const _hoisted_7 = { class: "clinic-note-container" }
const _hoisted_8 = { class: "clinic-note-contents" }
const _hoisted_9 = { class: "clinic-note-content-header" }
const _hoisted_10 = { class: "clinic-note-content-header-title" }
const _hoisted_11 = { class: "clinic-note-content-header-title-text" }
const _hoisted_12 = { class: "clinic-note-content-datetime" }
const _hoisted_13 = { class: "clinic-note-content-body" }
const _hoisted_14 = { class: "clinic-note-content-item body-condition" }
const _hoisted_15 = { class: "clinic-note-content-item-title" }
const _hoisted_16 = { class: "clinic-note-content-item-title-text" }
const _hoisted_17 = { class: "pc-only" }
const _hoisted_18 = { class: "clinic-note-content-item-period" }
const _hoisted_19 = { class: "clinic-note-content-item-period-date" }
const _hoisted_20 = { class: "clinic-note-content-item-period-date" }
const _hoisted_21 = { class: "clinic-note-content-item-graph" }
const _hoisted_22 = { class: "clinic-note-content-item" }
const _hoisted_23 = { class: "clinic-note-content-item-title" }
const _hoisted_24 = { class: "clinic-note-content-item-title-text" }
const _hoisted_25 = { class: "pc-only" }
const _hoisted_26 = {
  key: 0,
  class: "clinic-note-content-item-filled"
}
const _hoisted_27 = { class: "clinic-note-content-item-filled-list" }
const _hoisted_28 = { class: "clinic-note-content-item-filled-list-date" }
const _hoisted_29 = {
  key: 1,
  class: "clinic-note-content-item-unrecorded"
}
const _hoisted_30 = { class: "clinic-note-content-item" }
const _hoisted_31 = { class: "clinic-note-content-item-title" }
const _hoisted_32 = { class: "clinic-note-content-item-title-text" }
const _hoisted_33 = { class: "pc-only" }
const _hoisted_34 = {
  key: 0,
  class: "clinic-note-content-item-filled"
}
const _hoisted_35 = { class: "clinic-note-content-item-filled-list" }
const _hoisted_36 = { class: "clinic-note-content-item-filled-list-date" }
const _hoisted_37 = {
  key: 1,
  class: "clinic-note-content-item-unrecorded"
}
const _hoisted_38 = { class: "clinic-note-content-item" }
const _hoisted_39 = { class: "clinic-note-content-item-title" }
const _hoisted_40 = { class: "clinic-note-content-item-title-text" }
const _hoisted_41 = { class: "pc-only" }
const _hoisted_42 = {
  key: 0,
  class: "clinic-note-content-item-filled"
}
const _hoisted_43 = { class: "clinic-note-content-item-filled-list" }
const _hoisted_44 = { class: "clinic-note-content-item-filled-list-date" }
const _hoisted_45 = {
  key: 1,
  class: "clinic-note-content-item-unrecorded"
}
const _hoisted_46 = { class: "clinic-note-content-item" }
const _hoisted_47 = { class: "clinic-note-content-item-title" }
const _hoisted_48 = { class: "clinic-note-content-item-title-text" }
const _hoisted_49 = { class: "pc-only" }
const _hoisted_50 = {
  key: 0,
  class: "clinic-note-content-item-filled"
}
const _hoisted_51 = { class: "clinic-note-content-item-filled-list" }
const _hoisted_52 = {
  key: 1,
  class: "clinic-note-content-item-unrecorded"
}
const _hoisted_53 = { class: "clinic-note-content-item" }
const _hoisted_54 = { class: "clinic-note-content-item-title" }
const _hoisted_55 = { class: "clinic-note-content-item-title-text" }
const _hoisted_56 = { class: "pc-only" }
const _hoisted_57 = {
  key: 0,
  class: "clinic-note-content-item-filled"
}
const _hoisted_58 = { class: "clinic-note-content-item-filled-list" }
const _hoisted_59 = {
  key: 1,
  class: "clinic-note-content-item-unrecorded"
}
const _hoisted_60 = { class: "clinic-note-content-item" }
const _hoisted_61 = { class: "clinic-note-content-item-title" }
const _hoisted_62 = { class: "clinic-note-content-item-title-text" }
const _hoisted_63 = { class: "pc-only" }
const _hoisted_64 = {
  key: 0,
  class: "clinic-note-content-item-filled"
}
const _hoisted_65 = { class: "clinic-note-content-item-filled-list" }
const _hoisted_66 = {
  key: 1,
  class: "clinic-note-content-item-unrecorded"
}

import dayjs from "dayjs";
import { onMounted, computed, ref, reactive, watch } from "vue";
import { processing, processend } from "@/utils/view";
import { NoteData, NoteType, RawItem } from "./types";
import { _$t } from "@/utils/i18n";
import { useRouter } from "vue-router";

import ClinicNote from "@/models/myRecord/clinicNote/clinicNote";

import Header from "@/components/modules/base/Header.vue";
import Footer from "@/components/modules/base/Footer.vue";

import ConditionLineChart from "@/views/base/Chart/ConditionLineChart.vue";
import EditMultiNote from "@/views/pages/MyRecord/HospitalVisit/ClinicNote/EditMultiNote.vue";
import EditSingleNote from "@/views/pages/MyRecord/HospitalVisit/ClinicNote/EditSingleNote.vue";
import GraphSelector from "@/views/pages/MyRecord/HospitalVisit/ClinicNote/GraphSelector.vue";
import NoteSelector from "@/views/pages/MyRecord/HospitalVisit/ClinicNote/NoteSelector.vue";
import Tips from "@/views/pages/MyRecord/HospitalVisit/ClinicNote/Tips.vue";

import ErrorDialog from "@/views/base/CommonMessage.vue";

// 日付のローカライズ
const componentId = "healthcaredata02-01-d";
const activeMenu = "my-record";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    hospitalVisitId: {}
  },
  setup(__props: any) {

dayjs.locale("ja");

// --- props ----------------------------------------
const props = __props;

// --- Constants & Variables ------------------------------
const router = useRouter();

const hospitalVisitId = ref(props.hospitalVisitId);
const title = ref("");
const editType = ref(NoteType.Symptom);
const description = ref("");
// データ取得状況
const isDataStored = ref(false);
// モーダルの表示切替
const isInfo = ref(false);
const isEditMultiNote = ref(false); // 症状、心配・困りごと、薬の影響
const isEditSingleNote = ref(false); // 疑問、メモ、話した内容
const isGraphSelector = ref(false); // 体調グラフ
const isNoteSelector = ref(false); // 症状・こころノートからの転記
// 受診関連
const visitDate = ref(""); // 受診日
const visitTime = ref(""); // 受診時間
const lastVisitDate = ref(""); // 前回受診日
// 体調
const bodyConditions = ref<RawItem[]>([]);
// 診察ノート
const noteSymtoms = ref<NoteData[]>([]); // 症状
const noteConcerns = ref<NoteData[]>([]); // 心配事・困りごと
const noteOthers = ref<NoteData[]>([]); // その他
const noteEffects = ref<NoteData[]>([]); // 薬の影響
const noteQuestion = ref<NoteData | null>(null); // 疑問
const noteMemo = ref<NoteData | null>(null); // メモ
const noteConversation = ref<NoteData | null>(null); // 診察時に話した内容
const tempData = ref<NoteData[]>([]); // 転記中のデータ
let transcribing = false; // 転記中の管理
// 体調ラベル
const titleCond = { show: false };
// 初期チェックを入れる種別（症状・こころノート）
const selectedType = ref(NoteType.Symptom);
// グラフの表示期間
const startDate = ref("");
const endDate = ref("");
const formattedStartDate = computed(() => formatDate(startDate.value));
const formattedEndDate = computed(() => formatDate(endDate.value));
// 診察ノート表示用（未保存でも空白のみの状態は表示しない）
// 症状表示用
const displaySymptoms = computed(() =>
  noteSymtoms.value.filter((item) => item.content?.trim())
);
// 心配事・困りごと表示用
const displayConcerns = computed(() =>
  noteConcerns.value.filter((item) => item.content?.trim())
);
// その他表示用
const displayOthers = computed(() =>
  noteOthers.value.filter((item) => item.content?.trim())
);

// 診察ノートの編集対象管理
const editorCtrl: Partial<
  Record<
    NoteType,
    {
      editType: "single" | "multi";
      title: string;
      description: string;
      get: () => NoteData[] | NoteData | null;
      set: (data: NoteData | NoteData[]) => void;
    }
  >
> = {
  [NoteType.Symptom]: {
    editType: "multi",
    title: _$t("clinic_note_multi_edit_title_symptom"),
    description: "",
    get: () => noteSymtoms.value,
    set: (data) => (noteSymtoms.value = data as NoteData[]),
  },
  [NoteType.Concerns]: {
    editType: "multi",
    title: _$t("clinic_note_multi_edit_title_concerns"),
    description: "",
    get: () => noteConcerns.value,
    set: (data) => (noteConcerns.value = data as NoteData[]),
  },
  [NoteType.Effects]: {
    editType: "multi",
    title: _$t("clinic_note_multi_edit_title_treatment_effect"),
    description: "",
    get: () => noteEffects.value,
    set: (data) => (noteEffects.value = data as NoteData[]),
  },
  [NoteType.Other]: {
    editType: "multi",
    title: _$t("clinic_note_multi_edit_title_other"),
    description: "",
    get: () => noteOthers.value,
    set: (data) => (noteOthers.value = data as NoteData[]),
  },
  [NoteType.Memo]: {
    editType: "single",
    title: _$t("clinic_note_single_edit_title_memo"),
    description: _$t("clinic_note_single_edit_info_memo"),
    get: () => noteMemo.value,
    set: (data) => (noteMemo.value = data as NoteData),
  },
  [NoteType.Questions]: {
    editType: "single",
    title: _$t("clinic_note_single_edit_title_questions"),
    description: _$t("clinic_note_single_edit_info_questions"),
    get: () => noteQuestion.value,
    set: (data) => (noteQuestion.value = data as NoteData),
  },
  [NoteType.Conversation]: {
    editType: "single",
    title: _$t("clinic_note_single_edit_title_conversation"),
    description: _$t("clinic_note_single_edit_info_conversation"),
    get: () => noteConversation.value,
    set: (data) => (noteConversation.value = data as NoteData),
  },
};

// --- Dialogs -----------------------------------------------

// エラーダイアログ関連情報
const sessionErr = ref(false);
let errorDialogSet = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing(); // オーバレイを表示
    errorDialogSet.message = message;
    errorDialogSet.show = true;
  },
  close: (): void => {
    processend(); // オーバレイを非表示
    errorDialogSet.show = false;
    errorDialogSet.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// --- Functions ---------------------------------------------

// 和暦変換
function formatDate(date: string | null) {
  return date ? dayjs(date).format("YYYY年M月D日(ddd)") : "";
}

// 時間整形
function formatTime(time: string | null) {
  const today = dayjs().format("YYYY-MM-DD");
  return time ? dayjs(`${today} ${time}`).format("HH:mm") + " ～" : "";
}

// 初期設定
async function set() {
  const clinicNoteModel = new ClinicNote();
  // パラメータ設定
  const params = {
    hospitalVisitId: hospitalVisitId.value, // 病院受診ID
  };
  // 診察ノートを取得
  const [_model, response, err] = await clinicNoteModel.getClinicData(params);

  // エラー判定
  if (err) {
    const status = err.error.response.status;
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    // セッションエラー
    if (status === 408) sessionErr.value = true;
    errorDialogSet.open(decodedMessage);
    return;
  }

  // ### データ設定 ########

  // 体調
  startDate.value = response.data.clinicRecord.startDate;
  endDate.value = response.data.clinicRecord.endDate;

  // 訪問
  visitDate.value = response.data.userHospitalVisit.visit_date;
  visitTime.value = response.data.userHospitalVisit.visit_time;
  lastVisitDate.value = response.data.userHospitalVisit.last_visit_date;

  // 体調
  bodyConditions.value = response.data.userDailyConditions;

  // 診察ノート
  for (const item of response.data.clinicNotes) {
    switch (item.type) {
      // 症状
      case NoteType.Symptom:
        noteSymtoms.value = [...item.note];
        break;
      // 心配事・困りごと
      case NoteType.Concerns:
        noteConcerns.value = [...item.note];
        break;
      // 薬の影響
      case NoteType.Effects:
        noteEffects.value = [...item.note];
        break;
      // その他
      case NoteType.Other:
        noteOthers.value = [...item.note];
        break;
      // 疑問
      case NoteType.Questions:
        noteQuestion.value = item.note[0];
        break;
      // メモ
      case NoteType.Memo:
        noteMemo.value = item.note[0];
        break;
      // 診察時に話した内容
      case NoteType.Conversation:
        noteConversation.value = item.note[0];
        break;
    }
  }
  // データ取得完了
  isDataStored.value = true;
}

// ノート取得（複数）
function normalizeEditMulti(type: NoteType) {
  const item = editorCtrl[type];
  let result: NoteData[] = [];
  if (!transcribing) {
    if (item?.editType === "multi") {
      result = item.get() as NoteData[];
    }
  } else {
    // 転記中
    result = tempData.value;
  }
  return result;
}

// ノート取得（単一）
function normalizeEditSingle(type: NoteType) {
  const item = editorCtrl[type];
  let result: NoteData | null = null;
  if (item?.editType === "single") {
    result = item.get() as NoteData;
  }
  return result;
}

// --- Event Handlers --------------------------------------------

// インフォメーション表示
function onClickInfo() {
  isInfo.value = true;
}

// インフォメーション非表示
function onCloseInfo() {
  isInfo.value = false;
}

// 診察のコツ（記事395を相対パスで別タブ）
function onClickTips() {
  const href = router.resolve({
    name: "article/detail",
    // 本番用の記事IDを設定
    params: { articleId: "395" },
  }).href;
  window.open(href, "_blank", "noopener,noreferrer");
}

// 編集モーダル表示（体調グラフ）
function onEditCondition() {
  isGraphSelector.value = true; // 表示
}

// 保存（体調グラフ）
function onSaveGraphSelector(start: string, end: string) {
  // グラフデータ更新
  startDate.value = start;
  endDate.value = end;

  isGraphSelector.value = false; // 非表示
}

// キャンセル（体調グラフ）
function onCloseGraphSelector() {
  isGraphSelector.value = false; // 表示
}

// 編集モーダル表示（症状、心配・困りごと、その他、疑問、メモ、話した内容）
function onEdit(type: NoteType) {
  // パラメータ設定
  const item = editorCtrl[type]!;
  title.value = item.title;
  editType.value = type;
  if (item.editType === "multi") {
    isEditMultiNote.value = true; // 表示
  } else {
    description.value = item.description; // 画面説明
    isEditSingleNote.value = true; // 表示
  }
}

// キャンセル（症状、心配・困りごと、その他）
function onCloseEditMulti() {
  transcribing = false;
  isEditMultiNote.value = false; // 非表示
}

// キャンセル（疑問、メモ、話した内容）
function onCloseEditSingle() {
  isEditSingleNote.value = false; // 非表示
}

// 保存（疑問、メモ、話した内容）
function onSaveEditSingle(type: NoteType, data: NoteData) {
  let note = editorCtrl[type];
  note?.set(data);
  isEditSingleNote.value = false; // 非表示
}

// 保存（症状、心配・困りごと、その他）
function onSaveEditMulti(type: NoteType, data: NoteData[]) {
  // データ更新
  let note = editorCtrl[type];
  data?.sort((a: NoteData, b: NoteData) => {
    if (!a.input_date && !b.input_date) return 0;
    if (!a.input_date) return 1;
    if (!b.input_date) return -1;
    return dayjs(a.input_date).valueOf() - dayjs(b.input_date).valueOf();
  });
  note?.set(data);

  transcribing = false; // 転記終了
  isEditMultiNote.value = false; // 非表示
}

// 症状・こころノートからの転記選択時
function onTranscribe(type: NoteType, data: NoteData[]) {
  transcribing = true; // 転記中
  tempData.value = data; // 仮保存
  isEditMultiNote.value = false;

  selectedType.value = type;
  isNoteSelector.value = true; // 表示
}

// 症状・こころノート表示
function onSaveNoteSelector(type: NoteType, data: NoteData[]) {
  tempData.value = data;
  isNoteSelector.value = false;

  selectedType.value = type; // 表示
  isEditMultiNote.value = true;
}

// 症状・こころノート非表示
function onCloseNoteSelector() {
  isNoteSelector.value = false; // 非表示
  isEditMultiNote.value = true; // 編集に復帰
}
// ---- Vue Lifecycle Hooks -----------------------------------
onMounted(async () => await set());
watch([startDate, endDate], async () => await set());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: componentId }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header, { "active-menu": activeMenu }),
      (isDataStored.value)
        ? (_openBlock(), _createElementBlock("main", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "clinic-note-top-back-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("img", {
                  src: "/server/necs/images/arrow-right_icon.png",
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("clinic_note_link_back")), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("clinic_note_label_use_advice")), 1),
                _createElementVNode("a", {
                  href: "#",
                  class: "clinic-note-top-tips",
                  onClick: _withModifiers(onClickTips, ["prevent"])
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("img", {
                    class: "clinic-note-top-tips-icon",
                    src: "/server/necs/images/icon_note-guide_link.svg",
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("clinic_note_link_tips_medical_appointment")), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("img", {
                    src: "/server/necs/images/arrow_right_339db2.svg",
                    alt: ""
                  }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("clinic_note_label_note")), 1),
                  _createElementVNode("img", {
                    onClick: _withModifiers(onClickInfo, ["prevent"]),
                    src: "/server/necs/images/icon_info.svg",
                    alt: ""
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[10] || (_cache[10] = _createElementVNode("img", {
                      src: "/server/necs/images/icon_calendar_clinic_note.svg",
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("clinic_note_label_visit_date")), 1)
                  ]),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(formatDate(visitDate.value)) + " " + _toDisplayString(formatTime(visitTime.value)), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("clinic_note_label_condition")), 1),
                      _createElementVNode("button", {
                        class: "clinic-note-content-item-edit",
                        onClick: onEditCondition
                      }, [
                        _cache[11] || (_cache[11] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_edit_ec7400.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("clinic_note_label_edit")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("p", _hoisted_19, _toDisplayString(formattedStartDate.value), 1),
                      _cache[12] || (_cache[12] = _createElementVNode("span", null, "～", -1)),
                      _createElementVNode("p", _hoisted_20, _toDisplayString(formattedEndDate.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(ConditionLineChart, {
                        bodyConditions: bodyConditions.value,
                        pointSize: 8,
                        startDate: startDate.value,
                        endDate: endDate.value,
                        titleCond: titleCond,
                        class: "condition-line-chart"
                      }, null, 8, ["bodyConditions", "startDate", "endDate"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("clinic_note_label_symptoms")), 1),
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (onEdit(_unref(NoteType).Symptom))),
                        class: "clinic-note-content-item-edit"
                      }, [
                        _cache[13] || (_cache[13] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_edit_ec7400.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("clinic_note_label_edit")), 1)
                      ])
                    ]),
                    (displaySymptoms.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("ul", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displaySymptoms.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, [
                                _createElementVNode("p", null, [
                                  _cache[14] || (_cache[14] = _createElementVNode("span", null, "・", -1)),
                                  _createTextVNode(_toDisplayString(item.content), 1)
                                ]),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(formatDate(item.input_date)), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.$t("clinic_note_explain_symptoms")), 1))
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("clinic_note_label_concerns")), 1),
                      _createElementVNode("button", {
                        class: "clinic-note-content-item-edit",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (onEdit(_unref(NoteType).Concerns)))
                      }, [
                        _cache[15] || (_cache[15] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_edit_ec7400.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("clinic_note_label_edit")), 1)
                      ])
                    ]),
                    (displayConcerns.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("ul", _hoisted_35, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayConcerns.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, [
                                _createElementVNode("p", null, [
                                  _cache[16] || (_cache[16] = _createElementVNode("span", null, "・", -1)),
                                  _createTextVNode(_toDisplayString(item.content), 1)
                                ]),
                                _createElementVNode("span", _hoisted_36, _toDisplayString(formatDate(item.input_date)), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.$t("clinic_note_explain_concerns")), 1))
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("clinic_note_label_others")), 1),
                      _createElementVNode("button", {
                        class: "clinic-note-content-item-edit",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (onEdit(_unref(NoteType).Other)))
                      }, [
                        _cache[17] || (_cache[17] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_edit_ec7400.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("clinic_note_label_edit")), 1)
                      ])
                    ]),
                    (displayOthers.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("ul", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayOthers.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, [
                                _createElementVNode("p", null, [
                                  _cache[18] || (_cache[18] = _createElementVNode("span", null, "・", -1)),
                                  _createTextVNode(_toDisplayString(item.content), 1)
                                ]),
                                _createElementVNode("span", _hoisted_44, _toDisplayString(formatDate(item.input_date)), 1)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.$t("clinic_note_explain_others")), 1))
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t("clinic_note_label_questions")), 1),
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (onEdit(_unref(NoteType).Questions))),
                        class: "clinic-note-content-item-edit"
                      }, [
                        _cache[19] || (_cache[19] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_edit_ec7400.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("clinic_note_label_edit")), 1)
                      ])
                    ]),
                    (noteQuestion.value?.content.trim())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("p", null, _toDisplayString(noteQuestion.value.content), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(_ctx.$t("clinic_note_explain_questions")), 1))
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t("clinic_note_label_memo")), 1),
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (onEdit(_unref(NoteType).Memo))),
                        class: "clinic-note-content-item-edit"
                      }, [
                        _cache[20] || (_cache[20] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_edit_ec7400.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.$t("clinic_note_label_edit")), 1)
                      ])
                    ]),
                    (noteMemo.value?.content.trim())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("p", null, _toDisplayString(noteMemo.value.content), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(_ctx.$t("clinic_note_explain_memo")), 1))
                  ]),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.$t("clinic_note_label_conversation")), 1),
                      _createElementVNode("button", {
                        class: "clinic-note-content-item-edit",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (onEdit(_unref(NoteType).Conversation)))
                      }, [
                        _cache[21] || (_cache[21] = _createElementVNode("img", {
                          src: "/server/necs/images/icon_edit_ec7400.svg",
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t("clinic_note_label_edit")), 1)
                      ])
                    ]),
                    (noteConversation.value?.content.trim())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("p", null, _toDisplayString(noteConversation.value.content), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(_ctx.$t("clinic_note_explain_conversation")), 1))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(Footer, {
        "scroll-target": componentId,
        "active-menu": activeMenu
      })
    ]),
    (isInfo.value)
      ? (_openBlock(), _createBlock(Tips, {
          key: 0,
          onClose: onCloseInfo
        }))
      : _createCommentVNode("", true),
    (isGraphSelector.value)
      ? (_openBlock(), _createBlock(GraphSelector, {
          key: 1,
          hospitalVisitId: hospitalVisitId.value,
          bodyConditions: bodyConditions.value,
          lastVisitDate: lastVisitDate.value,
          startDate: startDate.value,
          endDate: endDate.value,
          onSave: onSaveGraphSelector,
          onClose: onCloseGraphSelector
        }, null, 8, ["hospitalVisitId", "bodyConditions", "lastVisitDate", "startDate", "endDate"]))
      : _createCommentVNode("", true),
    (isEditMultiNote.value)
      ? (_openBlock(), _createBlock(EditMultiNote, {
          key: 2,
          hospitalVisitId: hospitalVisitId.value,
          title: title.value,
          type: editType.value,
          clinicNotes: normalizeEditMulti(editType.value),
          onSave: onSaveEditMulti,
          onTranscribe: onTranscribe,
          onClose: onCloseEditMulti
        }, null, 8, ["hospitalVisitId", "title", "type", "clinicNotes"]))
      : _createCommentVNode("", true),
    (isEditSingleNote.value)
      ? (_openBlock(), _createBlock(EditSingleNote, {
          key: 3,
          hospitalVisitId: hospitalVisitId.value,
          title: title.value,
          description: description.value,
          type: editType.value,
          clinicNote: normalizeEditSingle(editType.value),
          onSave: onSaveEditSingle,
          onClose: onCloseEditSingle
        }, null, 8, ["hospitalVisitId", "title", "description", "type", "clinicNote"]))
      : _createCommentVNode("", true),
    (isNoteSelector.value)
      ? (_openBlock(), _createBlock(NoteSelector, {
          key: 4,
          type: selectedType.value,
          clinicNotes: normalizeEditMulti(selectedType.value),
          onSave: onSaveNoteSelector,
          onClose: onCloseNoteSelector
        }, null, 8, ["type", "clinicNotes"]))
      : _createCommentVNode("", true),
    (_unref(errorDialogSet).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 5 }, _unref(errorDialogSet), {
          onOk: _unref(errorDialogSet).close,
          onCancel: _unref(errorDialogSet).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ]))
}
}

})